import {
  IGNORED_URLS_SET,
  IGNORED_URLS_IN_PROGRESS,
  IGNORED_URLS_RESET,
} from '../actions/types';

const emptyState = {
  inProgress: false,
  items: [],
  // The per-account cap on ignore rules, as reported by GET /ignored-urls.
  // null when unknown (e.g. an older backend that only returns the array) — the
  // UI then falls back to the reactive limit alert instead of a proactive block.
  limit: null,
};

const initialState = emptyState;

export default (state = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case IGNORED_URLS_SET:
    {
      // Tolerate both the current shape ({ items, limit }) and the legacy shape
      // (a bare array) so the two sides can deploy in any order without breaking.
      const { data } = payload;
      const items = Array.isArray(data) ? data : data?.items ?? [];
      const limit = Array.isArray(data) ? state.limit : data?.limit ?? null;
      return { ...state,
        inProgress: false,
        items,
        limit,
      };
    }
    case IGNORED_URLS_IN_PROGRESS:
      return { ...state, inProgress: payload };
    case IGNORED_URLS_RESET:
      return initialState;
    default:
      break;
  }
  return state;
};
